import cn from 'classnames'

import { getQBRFormattedPercent } from '../../../../../../helpers/getQBRFormattedPercent'
import { getQBRFormattedUnit } from '../../../../../../helpers/getQBRFormattedUnit'
import styles from '../PlanAchievement.module.scss'

interface IGetUnitsShortedViewCellParameters {
  actualsUnits: number
  plansUnits: number
  actualsToPlans: number
  yoyActuals: number
}

export const getUnitsShortedViewCell = ({
  actualsUnits,
  plansUnits,
  actualsToPlans,
  yoyActuals,
}: IGetUnitsShortedViewCellParameters) => {
  return (
    <div className={styles.financialValue}>
      <p className={cn(styles.paragraph, styles.actuals)}>{getQBRFormattedUnit(actualsUnits)}</p>
      <p className={cn(styles.paragraph, styles.plans)}>{getQBRFormattedUnit(plansUnits)}</p>
      <p
        className={cn(styles.paragraph, {
          [styles.positive]: actualsToPlans > 100,
          [styles.negative]: actualsToPlans < 100,
        })}
      >
        {getQBRFormattedPercent(actualsToPlans)}
      </p>
      <p
        className={cn(styles.paragraph, {
          [styles.positive]: yoyActuals > 0,
          [styles.negative]: yoyActuals < 0,
          [styles.zero]: yoyActuals === 0,
        })}
      >
        {getQBRFormattedPercent(yoyActuals, 'exceptZero')}
      </p>
    </div>
  )
}
